import { Component, Input } from '@angular/core';
import { ProgressSpinnerModule } from 'primeng/progressspinner';

@Component({
  selector: 'lib-restaurant-loader-ui',
  imports: [ProgressSpinnerModule],
  templateUrl: './restaurant-loader-ui.html',
  styleUrl: './restaurant-loader-ui.scss',
})
export class RestaurantLoaderUi {

  @Input() loader = false;
  
}
